import { Level, CardioOrResistance } from 'fitbeat.models';
import { BeginnerLevelIcon } from './BeginnerLevelIcon';
import BuildIcon from '../../../assets/icons/activity-types/functional-strength-outlined.svg'
import BurnIcon from '../../../assets/icons/activity-types/functional-cardio-outlined.svg'
import BalanceIcon from '../../../assets/icons/activity-types/functional-pilates-outlined.svg'
import { ExpertLevelIcon } from './ExpertLevelIcon';
import { IntermediateLevelIcon } from './IntermediateLevelIcon';

export const SkillLevelIconMap = {
  [Level.Beginner]: BeginnerLevelIcon,
  [Level.Basic]: IntermediateLevelIcon,
  [Level.Intermediate]: ExpertLevelIcon,
};

export const WorkoutTypeIconMap = {
  [CardioOrResistance.Cardio]: BurnIcon,
  [CardioOrResistance.Resistance]: BuildIcon,
  [CardioOrResistance.Balance]: BalanceIcon,
};
